import http from './httpRequest';

/**
 * 朋友圈API接口
 */

/**
 * 发布朋友圈
 * @param {Object} data - 朋友圈数据
 * @param {String} data.content - 内容(最多5000字符)
 * @param {Array} data.attachments - 附件列表(最多9个)
 * @param {Number} data.visibility - 可见范围 0:公开(所有好友可见) 1:仅自己可见
 * @returns {Promise<Long>} 朋友圈ID
 */
export function publishMoment(data) {
  return http({
    url: '/moment/publish',
    method: 'post',
    data
  });
}

/**
 * 删除朋友圈
 * @param {Object} data - 删除数据
 * @param {Long} data.momentId - 朋友圈ID
 * @returns {Promise<Void>}
 */
export function deleteMoment(data) {
  return http({
    url: '/moment/delete',
    method: 'delete',
    data
  });
}

/**
 * 设置/取消朋友圈置顶
 * @param {Object} data - 置顶数据
 * @param {Long} data.momentId - 朋友圈ID
 * @param {Boolean} data.isTop - 是否置顶
 * @returns {Promise<Void>}
 */
export function setMomentTop(data) {
  return http({
    url: '/moment/top',
    method: 'put',
    data
  });
}

/**
 * 评论/点赞朋友圈
 * @param {Object} data - 评论数据
 * @param {Long} data.momentId - 朋友圈ID
 * @param {String} data.content - 评论内容
 * @param {Number} data.type - 类型: 1-评论, 2-点赞
 * @returns {Promise<Void>}
 */
export function commentMoment(data) {
  return http({
    url: '/moment/comment',
    method: 'post',
    data
  });
}

/**
 * 取消点赞
 * @param {Long} momentId - 朋友圈ID
 * @returns {Promise<Void>}
 */
export function unlikeMoment(momentId) {
  return http({
    url: `/moment/unlike/${momentId}`,
    method: 'delete'
  });
}

/**
 * 删除评论
 * @param {Long} commentId - 评论ID
 * @returns {Promise<Void>}
 */
export function deleteComment(commentId) {
  return http({
    url: `/moment/comment/${commentId}`,
    method: 'delete'
  });
}

/**
 * 获取朋友圈列表
 * @param {Number} page - 页码
 * @param {Number} size - 每页大小
 * @returns {Promise<Page>} 朋友圈分页数据
 */
export function getMomentList(page = 1, size = 10) {
  return http({
    url: '/moment/list',
    method: 'get',
    params: { page, size }
  });
}

/**
 * 获取指定用户的朋友圈
 * @param {Long} userId - 用户ID
 * @param {Number} page - 页码
 * @param {Number} size - 每页大小
 * @returns {Promise<Page>} 朋友圈分页数据
 */
export function getUserMoments(userId, page = 1, size = 10) {
  return http({
    url: `/moment/user/${userId}`,
    method: 'get',
    params: { page, size }
  });
}

/**
 * 获取朋友圈详情
 * @param {Long} momentId - 朋友圈ID
 * @returns {Promise<MomentVO>} 朋友圈详情
 */
export function getMomentDetail(momentId) {
  return http({
    url: `/moment/${momentId}`,
    method: 'get'
  });
}

export default {
  publishMoment,
  deleteMoment,
  setMomentTop,
  commentMoment,
  unlikeMoment,
  deleteComment,
  getMomentList,
  getUserMoments,
  getMomentDetail
};
